const Forgetpassword = () => import(/* webpackChunkName: "page-login" */ '@/modules/forgetpassword/Forgetpassword')
const Resetpassword = () => import(/* webpackChunkName: "page-login" */ '@/modules/forgetpassword/Resetpassword')

export default [
    {
        path: '/forgetpassword',
        name: 'forgetpassword',
        component: Forgetpassword,
        meta: {
            needLogin: false,
            fullscreen: true,
            title: '找回密码',
        },
    },
    {
        path: '/resetpassword',
        name: 'resetpassword',
        component: Resetpassword,
        meta: {
            needLogin: false,
            fullscreen: true,
            title: '重置密码',
        },
    },
]
